import React from 'react';

// import slot from "../../_asset/image/logo/slot.png"
import slot from "../../_asset/image/logo/RMLogo.png"
import slotText from "../../_asset/image/logo/logo-text.png"

export default function Logo({ link, text }: { link: boolean, text: boolean }) {
    return (
        <div className={`logo ${link ? '--pointer' : ''}`} onClick={e => {
            if (link) {
                window.location.href = '/'
            }
        }}>
            <div className="slot">
                <img src={text ? slotText : slot} />
            </div>
        </div>
    )
}
Logo.defaultProps = {
    link: false,
    text: false
}